import { render, staticRenderFns } from "./fans_portrait.vue?vue&type=template&id=3a8c44b1&scoped=true"
import script from "./fans_portrait.vue?vue&type=script&lang=js"
export * from "./fans_portrait.vue?vue&type=script&lang=js"
import style0 from "./fans_portrait.vue?vue&type=style&index=0&id=3a8c44b1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8c44b1",
  null
  
)

export default component.exports